const fieldValue = (id) => {
  const field = document.getElementById(id);
  return field ? field.value : "";
};

const initializeSubscriptionBillingChange = () => {
  const preview = document.querySelector("[data-subscription-billing-change]");
  if (!preview) return;

  const watchedIds = [
    "administration_subscription_amount",
    "administration_subscription_billing_frequency"
  ];
  const fields = watchedIds.map((id) => document.getElementById(id)).filter(Boolean);
  const originals = {
    administration_subscription_amount: preview.dataset.originalAmount || "",
    administration_subscription_billing_frequency: preview.dataset.originalFrequency || ""
  };

  const refresh = () => {
    const changed = fields.some((field) => fieldValue(field.id) !== originals[field.id]);
    preview.hidden = !changed;
    if (!changed) return;

    const frequency = document.getElementById("administration_subscription_billing_frequency");
    const selectedFrequency = frequency && frequency.options[frequency.selectedIndex]
      ? frequency.options[frequency.selectedIndex].text
      : "de gekozen frequentie";
    const summary = preview.querySelector("[data-subscription-billing-change-summary]");
    if (summary) {
      summary.textContent = `De vrije planning wordt vanaf de getoonde factuurgrens opnieuw berekend op basis van ${selectedFrequency.toLowerCase()}.`;
    }
  };

  fields.forEach((field) => {
    field.addEventListener("change", refresh);
    field.addEventListener("input", refresh);
  });
  refresh();
};

const initializeIndexationDate = () => {
  const mode = document.getElementById("administration_subscription_indexation_mode");
  const date = document.getElementById("administration_subscription_first_indexation_on");
  if (!mode || !date) return;

  const formattedSuggestedDate = () => {
    const value = date.dataset.suggestedIndexationOn || "";
    if (!value) return "";
    const [year, month, day] = value.split("-");
    return `${new Intl.DateTimeFormat("nl-NL", {
      day: "2-digit", month: "long", year: "numeric", timeZone: "UTC"
    }).format(new Date(Date.UTC(Number(year), Number(month) - 1, Number(day))))} (automatisch)`;
  };

  mode.addEventListener("change", () => {
    const label = document.querySelector("[data-indexation-date-label]");
    if (mode.value === "none") {
      date.value = "";
      if (label) label.textContent = formattedSuggestedDate();
      return;
    }

    if (!date.value) date.value = date.dataset.suggestedIndexationOn || "";
    if (label && date.value) {
      const [year, month, day] = date.value.split("-");
      label.textContent = `${new Intl.DateTimeFormat("nl-NL", {
        day: "2-digit", month: "long", year: "numeric", timeZone: "UTC"
      }).format(new Date(Date.UTC(Number(year), Number(month) - 1, Number(day))))} (automatisch)`;
    }
  });
};

const initializeSubscriptionChanges = () => {
  initializeSubscriptionBillingChange();
  initializeIndexationDate();
};

document.addEventListener("DOMContentLoaded", initializeSubscriptionChanges);
document.addEventListener("turbolinks:load", initializeSubscriptionChanges);
